import { render } from "./intake_desk.html?vue&type=template&id=5aed9d06&external"
import script from "./intake_desk.js?vue&type=script&lang=js&external"
export * from "./intake_desk.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__